'use strict';

var styled = require('styled-components');
var component = require('../Icon/component.js');
require('react');
require('../Tooltip/component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const textColorByColor = (theme) => ({
    blue: theme.designTokens.highlightedIconBlueTextColor,
    green: theme.designTokens.highlightedIconGreenTextColor,
    orange: theme.designTokens.highlightedIconOrangeTextColor,
    purple: theme.designTokens.highlightedIconPurpleTextColor,
    red: theme.designTokens.highlightedIconRedTextColor,
    yellow: theme.designTokens.highlightedIconYellowTextColor,
    grey: theme.designTokens.highlightedIconGreyTextColor,
});
const backgroundColorByColor = (theme) => ({
    blue: theme.designTokens.highlightedIconBlueBackgroundColor,
    green: theme.designTokens.highlightedIconGreenBackgroundColor,
    orange: theme.designTokens.highlightedIconOrangeBackgroundColor,
    purple: theme.designTokens.highlightedIconPurpleBackgroundColor,
    red: theme.designTokens.highlightedIconRedBackgroundColor,
    yellow: theme.designTokens.highlightedIconYellowBackgroundColor,
    grey: theme.designTokens.highlightedIconGreyBackgroundColor,
});
const Container = styled__default.default.span `
  display: inline-block;
  padding: ${({ theme }) => theme.designTokens.highlightedIconContainerPadding};
  border-radius: ${({ theme }) => theme.designTokens.highlightedIconRadius};
  color: ${({ theme, color }) => textColorByColor(theme)[color]};
  background: ${({ theme, color }) => backgroundColorByColor(theme)[color]};
`;
const StyledIcon = styled__default.default(component.Icon) `
  padding: ${({ theme }) => theme.designTokens.highlightedIconPadding};
`;
const Styled = {
    Container,
    Icon: StyledIcon,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
